/*
 * @Description: 
 * @Author: liushuai
 * @LastEditTime: 2020-05-27 20:00:27
 */
export var TRANSFORM = {
  /* 图片初始状态 */
  INIT_STATE: {
    rotate: 0,
    scale: 1,
    left: 0,
    top: 0
  },

  /* 图片缩放倍率 */
  SCALE_RATE: 1.2,
  MAX_SCALE_RATE: Math.pow(1.2, 3),
  MIN_SCALE_RATE: 1 / Math.pow(1.2, 3),

  /* 图片旋转度数 */
  ROTATE_DEG: 90
};
export var PAGE_SIZE = 5;
export var NO_INVOICE_IMG = 'https://cmimg.maycur.com/front-static-resource/imgs/noInvoice.png';
//# sourceMappingURL=constant.js.map
